// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__mgTx8","label":"LabeledBox_label__vlMGv"};